export default __webpack_public_path__ + "static/media/road7.78afef51.jpeg";